import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import break_box from '../../../../images/product/break_box.png';
import lunch_box from '../../../../images/product/meals_box.png';
import new_gif from '../../../../images/new_subs.gif';

import Edit from '../../../modal/Production_Management/Manage_Quality_Analysis/Edit';
import View from '../../../modal/Production_Management/Manage_Quality_Analysis/View';
import ViewItem from '../../../modal/Production_Management/Manage_Quality_Analysis/View';
import EditItem from '../../../modal/Production_Management/Manage_Quality_Analysis/Edit';
import WorkChecklist from '../../../modal/Production_Management/Manage_Quality_Analysis/WorkChecklist';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';

import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/items.jpg';
import Chapathi from '../../../../images/items/chapati.jpg';
import uthappam from '../../../../images/items/podi_uthappam.png';
import AddWastage from '../../../modal/Production_Management/Manage_Quality_Analysis/AddWastage';
import Rework from '../../../modal/Production_Management/Manage_Quality_Analysis/Rework';
import moment from 'moment';
import axios from 'axios';
 
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
 


const Quality_Analysis = () => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    }; 
    const onClose = () => {
        setFilterOpen(false);
    };
 
    const [selectedOption, setSelectedOption] = useState(null);

    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const handleModalToggle_Edit = (assignment) => {
        setSelectedAssignment(assignment);
        setModalType("EditQuality");
        setOpen(true);
    };

    const handleModalToggle_Work = (assignment) => {
        setSelectedAssignment(assignment);
        setModalType("WorkChecklist");
        setOpen(true);
    };

  

    // const handleModalToggle_Edit = () => {
    //     setModalType("EditQuality");  // Set the modal type to "Add"
    //     setOpen(true);
    // };

 
    // const handleModalToggle_View = () => { 
    //     setModalType("ViewQuality");  // Set the modal type to "Add"
    //     setOpen(true);
    // };

        const handleModalToggle_View = (assignment) => {
        setSelectedAssignment(assignment);
        setModalType("ViewQuality");
        setOpen(true);
    };


    const [selectedAssignmentSno, setSelectedAssignmentSno] = useState(null);
    // const [selectedAssignment, setSelectedAssignment] = useState(null);

    // const handleModalToggle_AddWastage = () => {
    //     setModalType("AddWastage");  // Set the modal type to "Add"
    //     setOpen(true);
    // };

//     const handleModalToggle_AddWastage = (sno) => {
//     setSelectedAssignmentSno(sno);   // Store the selected item sno
//     setModalType("AddWastage");      // Set modal type
//     setOpen(true);                   // Open modal
// };

const handleModalToggle_AddWastage = (assignment) => {
    setSelectedAssignment(assignment);
    setModalType("AddWastage");
    setOpen(true);
};



    const handleModalToggle_Rework = () => {
        setModalType("Rework");  // Set the modal type to "Add"
        setOpen(true);
    };
 
    
        const baseURL = process.env.REACT_APP_API_BASE_URL;
    
        const tableRef = useRef(null);
    
        const [modalType, setModalType] = useState("");
        const [open, setOpen] = useState(false);
        const [filterOpen, setFilterOpen] = useState(false);
        const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
        const [today_fil_value, setTodayFilValue] = useState(new Date());
        const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(moment().startOf('isoWeek').toDate());
        const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(moment().endOf('isoWeek').toDate());
        const [month_fil_value, setMonthFilValue] = useState(new Date());
        const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
        const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    
        const [assignments, setAssignments] = useState([]);
        const [page, setPage] = useState(1);
        const [totalPages, setTotalPages] = useState(1);
        const [searchTerm, setSearchTerm] = useState('');
        const [perPage, setPerPage] = useState(25);
        const [TotalCount, setTotalCount] = useState('');
    
        const date_fil_options = [
            { value: "all", label: "All" },
            { value: "today", label: "Today" },
            { value: "this_week", label: "This week" },
            { value: "this_month", label: "This Month" },
            { value: "custom", label: "Custom Date" }
        ];
 
    
            const fetchWork = (isFiltered = true) => {
            const params = {};
    
             if (isFiltered && date_fil_selt_value !== "all") {
                switch (date_fil_selt_value) {
                    case "today":
                    case "date":
                        params.filter = "date"; 
                        params.date = moment(today_fil_value.toDate?.() || today_fil_value).format("YYYY-MM-DD");
    
                        break;
    
     
                    case "this_week":
                        params.filter = "week";
                        params.start_date = moment(week_stdt_fil_value.toDate?.() || week_stdt_fil_value).format("YYYY-MM-DD");
                        params.end_date = moment(week_eddt_fil_value.toDate?.() || week_eddt_fil_value).format("YYYY-MM-DD");
                        break;
                    case "this_month":
                        const month = moment(month_fil_value.toDate?.() || month_fil_value).format("YYYY-MM");
                        params.filter = "month";
                        params.start_month = month;
                        params.end_month = month;
                        break;
                    case "custom":
                        params.filter = "custom";
                        params.start_date = moment(custom_stdt_fil_value.toDate?.() || custom_stdt_fil_value).format("YYYY-MM-DD");
                        params.end_date = moment(custom_eddt_fil_value.toDate?.() || custom_eddt_fil_value).format("YYYY-MM-DD");
                        break;
                    default:
                        break;
                }
            }
    
            axios.get(`${baseURL}/assignments`, { params })
                .then(res => {
                    if (res.data?.data) {
                        setAssignments(res.data.data);
                        setTotalCount(res.data.count);
                        setTotalPages(Math.ceil(res.data.count / perPage));
    
                        setTimeout(() => {
                            if ($.fn.dataTable.isDataTable(tableRef.current)) {
                                $(tableRef.current).DataTable().destroy();
                            }
                            $(tableRef.current).DataTable({
                                dom: 'Bfrtip',
                                buttons: [
                                    { extend: 'csv', className: 'buttons-csv d-none' },
                                    { extend: 'excel', className: 'buttons-excel d-none' },
                                    { extend: 'print', className: 'buttons-print d-none' }
                                ]
                            });
                        }, 100);
                    }
                })
                .catch(err => {
                    console.error("API Error: ", err);
                });
        };
    
        const handleResetFilter = () => {
            setDateFilSeltValue("all");
            setTodayFilValue(new Date());
            setWeekSTDTFilValue(moment().startOf('isoWeek').toDate());
            setWeekEDDTFilValue(moment().endOf('isoWeek').toDate());
            setMonthFilValue(new Date());
            setCustomSTDTFilValue(new Date());
            setCustomEDDTFilValue(new Date());
            setPage(1);
            setFilterOpen(false);
            fetchWork(false);
        };
    
        const handleGoFilter = () => {
            setPage(1);
            setFilterOpen(false);
            const applyFilters = date_fil_selt_value !== "all";
            fetchWork(applyFilters);
        };
    
        const exportToCSV = () => {
            const csvRows = [];
            const headers = ['Item', 'Category / Sub Category', 'Product Category', 'Qty / Units', 'Assign Works', 'Status'];
            csvRows.push(headers.join(','));
    
            assignments.forEach(item => {
                const row = [
                    item.item_info?.name,
                    `${item.item_info?.category} / ${item.item_info?.sub_category}`,
                    item.product_info?.product_name || '-',
                    `${item.product_info?.quantity} ${item.product_info?.measurement_unit}`,
                    item.stagging_with_staff?.map(staff => staff.staff_name).join(', '),
                    'Work Not Started'
                ];
                csvRows.push(row.join(','));
            });
    
            const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, 'work_assignments.csv');
        };
    
        const exportToExcel = () => {
            const data = assignments.map(item => ({
                'Item': item.item_info?.name,
                'Category / Sub Category': `${item.item_info?.category} / ${item.item_info?.sub_category}`,
                'Product Category': item.product_info?.product_name || '-',
                'Qty / Units': `${item.product_info?.quantity} ${item.product_info?.measurement_unit}`,
                'Assign Works': item.stagging_with_staff?.map(staff => staff.staff_name).join(', '),
                'Status': 'Work Not Started'
            }));
    
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Assignments');
            XLSX.writeFile(workbook, 'work_assignments.xlsx');
        };
    
      
        const printTable = () => {
        const printContent = document.getElementById('work_assignment_table')?.outerHTML || '<p>No Data</p>';
        const newWin = window.open('', '_blank');
        newWin.document.write('<html><head><title>Work Assignment Print</title>');
        newWin.document.write('<style>table { width: 100%; border-collapse: collapse; } td, th { padding: 6px; border: 1px solid #ccc; }</style>');
        newWin.document.write('</head><body>');
        newWin.document.write('<h2>Work Assignment</h2>');
        newWin.document.write(printContent);
        newWin.document.write('</body></html>');
        newWin.document.close();
        newWin.print();
    };
    
    
        const handleExport = (type) => {
            switch (type) {
                case 'csv':
                    exportToCSV();
                    break;
                case 'excel':
                    exportToExcel();
                    break;
                case 'print':
                    printTable();
                    break;
                default:
                    break;
            }
        };
    
        useEffect(() => {
            fetchWork(false);
        }, []);

        
    

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Quality Analysis</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                 
                </div>
                {/* {open && modalType === "EditQuality" && (
                    <Edit show={open} onClose={() => setOpen(false)} /> 
                )} */}

                {open && modalType === "EditQuality" && (
                            <EditItem
                                show={open}
                                onClose={() => setOpen(false)}
                                data={selectedAssignment}
                            />
                            )}

                 {open && modalType === "WorkChecklist" && (
                            <WorkChecklist
                                show={open}
                                onClose={() => setOpen(false)}
                                data={selectedAssignment}
                            />
                            )}

                {open && modalType === "ViewQuality" && (
                            <ViewItem
                                show={open}
                                onClose={() => setOpen(false)}
                                data={selectedAssignment}
                            />
                            )}
                


                {/* {open && modalType === "ViewQuality" && (
                    <View show={open} onClose={() => setOpen(false)} />
                )} */}
                {/* {open && modalType === "AddWastage" && (
                    <AddWastage show={open} onClose={() => setOpen(false)} />
                )} */}
{/* 

                        <AddWastage
            show={modalType === "AddWastage" && open}
            onClose={() => setOpen(false)}
            assignmentSno={selectedAssignmentSno}
        /> */}

        {modalType === "AddWastage" && open && selectedAssignment && (
    <AddWastage
        show={true}
        onClose={() => setOpen(false)}
        assignment={selectedAssignment}
    />
)}



                {open && modalType === "Rework" && (
                    <Rework show={open} onClose={() => setOpen(false)} />
                )}

            </div>
            <div className='d-flex justify-content-end'>
                {/* <label className='fs-6 text-danger font-w600'>07-May-2025</label>  */}
                 <label className='fs-6 text-danger font-w600'>
                {new Date().toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })}
            </label>
            </div>
            <div className="table-container">

                  <div className="d-flex justify-content-between align-items-center mb-3">
                {/* Per Page Dropdown */}
                <div>
                    <label className="me-2">Show</label>
                    <select className="form-select d-inline w-auto"
                        style={{ fontSize: '0.85rem', height: '30px' }}
                        value={perPage}
                        onChange={(e) => {
                            setPerPage(Number(e.target.value));
                            setPage(1);
                        }}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                {/* Search Box */}
                <div>
                    <input
                        type="text"
                        style={{ fontSize: '0.85rem', height: '40px' }}
                        placeholder="Search..."
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPage(1);
                        }}
                    />
                </div>
            </div>


                <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Item</th>
                            <th className='min-w-80px'>Product Category</th>
                            <th className='min-w-80px'>Staff</th>
                            <th className='min-w-100px'>Score</th>
                            <th className='min-w-100px text-center'>Checklist Status</th>
                            <th className='min-w-100px'>Deliverable</th>
                            <th className='min-w-100px'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">

                        {assignments.length > 0 ? assignments.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                        <LightGallery
                                            onInit={onInit}
                                            speed={500}
                                            plugins={[lgThumbnail, lgZoom]} 
                                        >
                                            <div data-src={item.item_info?.image || idly}  className='border rounded px-1 py-0'>
                                                <img src={item.item_info?.image || idly}  alt={item.item_info?.name} className='cursor-pointer w-45px h-45px' />
                                            </div>
                                        </LightGallery>
                                        <div>
                                            <label className='text-black font-w400 fs-7'>{item.item_info?.name}</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-dark">{item.item_info?.category}</label>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                             
                                   <td>
                                {item.product_info?.length > 0 ? (
                                    item.product_info.map((prod, idx) => (
                                    <div key={idx} className="mb-1">
                                         <label className='text-info font-w600 fs-7'>
                                        {prod.category_name || '-'}
                                        </label>
                                    </div>
                                    ))
                                ) : (
                                     <label className='text-info font-w600 fs-7'>-</label>
                                )}
                                </td>

                                
                                  <td>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                        overlay={<Tooltip className='toltip-popover'>
                                            <span className='fs-8 text-white fw-semibold'>{item.stagging_with_staff?.map(staff => staff.staff_name).join(', ')}</span>
                                        </Tooltip>}
                                    >
                                        <div className='text-truncate mw-200px text-black font-w400 fs-7'>{item.stagging_with_staff?.map(staff => staff.staff_name).join(', ')}</div>
                                    </OverlayTrigger>
                                </td>
                                <td>

                                  
                                    <Badge bg="success" className='text-white font-w600 fs-8 px-1 py-0'>00</Badge>
                                    <span> / </span>
                                    <Badge bg="info" className='text-white font-w600 fs-8 px-1 py-0'>05</Badge>
                                </td>
                                <td className='text-center'>
                                    <Badge bg="danger" className='py-0 px-1 fs-8'>Pending</Badge>
                                </td>
                                <td>
                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                        <input className="form-check-input me-2" type="checkbox" role="switch" />
                                    </div>
                                </td>
                                <td>

                                     <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                        // onClick={handleModalToggle_View}
                                        onClickCapture={() => handleModalToggle_View(item)}
                                        >
                                            <span><i class="fa-solid fa-eye fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger> 


                                     <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                        // onClick={handleModalToggle_Edit}
                                        onClickCapture={() => handleModalToggle_Edit(item)}
                                        >
                                            <span><i className="fa-solid fa-edit fs-6 mt-1"></i></span> 
                                        </Button>
                                    </OverlayTrigger>

                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Wastage</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                        // onClick={handleModalToggle_AddWastage}
                                           onClick={() => handleModalToggle_AddWastage(item)}
                                        >
                                            <span><i className="fa-solid fa-trash-restore fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </td>
                            </tr>
                         )) : (
                        <tr><td colSpan="7" className="text-center text-muted py-4">No Data Found</td></tr>
                        )}

                        {/* <tr>
                            <td>
                                <div className="d-flex align-items-center justify-content-start gap-2">
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        <div data-src={idly} className='border rounded px-1 py-0'>
                                            <img src={idly} alt="Podi Idly" className='cursor-pointer w-45px h-45px' />
                                        </div>
                                    </LightGallery>
                                    <div>
                                        <label className='text-black font-w400 fs-7'>Podi Idly</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">Steamed Food</label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <label className='text-info font-w600 fs-7'>Break Box</label>
                            </td>

                            <td> 
                                <label className='text-black font-w400 fs-7'>Mithra</label>
                            </td>
                            <td>
 
                                <Badge bg="success" className='text-white font-w600 fs-8 px-1 py-0'>03</Badge>
                                <span> / </span>
                                <Badge bg="info" className='text-white font-w600 fs-8 px-1 py-0'>05</Badge>
                            </td>
                            <td className='text-center'>
                                <Badge bg="success" className='py-0 px-1 fs-8'>Completed</Badge>
                            </td>
                            <td>
                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                    <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked />
                                </div>
                            </td>
                            <td>
                                <span class="text-end">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_View}>
                                            <span><i class="fa-solid fa-eye fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger> 
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Wastage</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_AddWastage}>
                                            <span><i className="fa-solid fa-trash-restore fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </span>
                            </td>
                        </tr> */}
                        {/* <tr>
                            <td>
                                <div className="d-flex align-items-center justify-content-start gap-2">
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        <div data-src={Chapathi} className='border rounded px-1 py-0'>
                                            <img src={Chapathi} alt="Podi Idly" className='cursor-pointer w-45px h-45px' />
                                        </div>
                                    </LightGallery>
                                    <div>
                                        <label className='text-black font-w400 fs-7'>Chappathi</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">Steamed Food</label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <label className='text-info font-w600 fs-7'>Break Box</label>
                            </td>

                            <td>
                                <label className='text-black font-w400 fs-7'>Mithra, Anusha, Prabha</label>
                            
                            </td>
                            <td>
                                
                                <Badge bg="success" className='text-white font-w600 fs-8 px-1 py-0'>01</Badge>
                                <span> / </span>
                                <Badge bg="info" className='text-white font-w600 fs-8 px-1 py-0'>05</Badge>
                               
                            </td>
                            <td className='text-center'>
                                <Badge bg="success" className='py-0 px-1 fs-8'>Completed</Badge>
                            </td>
                            <td>
                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                    <input className="form-check-input me-2" type="checkbox" role="switch" />
                                </div>
                            </td>
                            <td>
                                <span class="text-end">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_View}>
                                            <span><i class="fa-solid fa-eye fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_Edit}>
                                            <span><i className="fa-solid fa-edit fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Rework</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_Rework}>
                                            <span><i className="fa fa-redo fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Wastage</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_AddWastage}>
                                            <span><i className="fa-solid fa-trash-restore fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>

                                </span>
                            </td>
                        </tr> */}
                    </tbody>
                </table>

                 {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                        {assignments.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + assignments.length} of {TotalCount} entries
                            </span>
                        ) : (
                            <span className="text-muted">Showing 0 to 0 of 0 entries</span>
                        )}
                    </div>
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>

            </div>

 
    <Drawer
            anchor="right"
            open={filterOpen}
            onClose={() => setFilterOpen(false)}
            disableEscapeKeyDown
            BackdropProps={{
                onClick: (e) => e.stopPropagation(),
            }}
            sx={{
                width: 400,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 400,
                    boxSizing: 'border-box',
                },
                '@media (max-width: 375px)': {
                    '& .MuiDrawer-paper': {
                        width: 320,
                    },
                },
                '@media (max-width: 320px)': {
                    '& .MuiDrawer-paper': {
                        width: 280,
                    },
                },
            }}
        >
            <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                <h5 className='fs-4' style={{ color: '#ea1d25' }}>Manage Work Quality Analysis Filter</h5>
                <div>
                    <Button variant="" type="button" size='sm' onClick={() => setFilterOpen(false)}>
                        <span className='fs-2'>×</span>
                    </Button>
                </div>
            </div>

            <div className='card border-0'>
                <div className='card-body py-0'>
                    <div className='row mb-2 py-2'>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date</label>
                            <Select
                                value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                onChange={(selectedOption) => {
                                    const selectedValue = selectedOption.value;
                                    setDateFilSeltValue(selectedValue);

                                    if (selectedValue === "this_week") {
                                        setWeekSTDTFilValue(moment().startOf('isoWeek').toDate());
                                        setWeekEDDTFilValue(moment().endOf('isoWeek').toDate());
                                    }

                                    if (selectedValue === "today") {
                                        setTodayFilValue(new Date());
                                    }

                                    if (selectedValue === "this_month") {
                                        setMonthFilValue(new Date());
                                    }

                                    if (selectedValue === "custom") {
                                        const now = new Date();
                                        setCustomSTDTFilValue(now);
                                        setCustomEDDTFilValue(now);
                                    }
                                }}
                                options={date_fil_options}
                                menuPlacement="top"
                            />
                        </div>
 
                        {["today", "date"].includes(date_fil_selt_value) && (
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date</label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                </div>
                                <DatePicker
                                    value={today_fil_value}
                                    onChange={setTodayFilValue}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                    )}


                        {date_fil_selt_value === "this_week" && (
                            <>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={week_stdt_fil_value}
                                            onChange={setWeekSTDTFilValue}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={week_eddt_fil_value}
                                            onChange={setWeekEDDTFilValue}
                                            format="DD-MM-YYYY"
                                            calendarPosition="top-end"
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        {date_fil_selt_value === "this_month" && (
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">This Month</label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-calendar-days fs-4'></i>
                                    </div>
                                    <DatePicker
                                        value={month_fil_value}
                                        onChange={setMonthFilValue}
                                        format="MMM-YYYY"
                                        calendarPosition="top"
                                        mode="single"
                                        onlyMonthPicker
                                    />
                                </div>
                            </div>
                        )}

                        {date_fil_selt_value === "custom" && (
                            <>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={custom_stdt_fil_value}
                                            onChange={setCustomSTDTFilValue}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={custom_eddt_fil_value}
                                            onChange={setCustomEDDTFilValue}
                                            format="DD-MM-YYYY"
                                            calendarPosition="top-end"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-center gap-1 pb-3">
                    <Button className="me-2 btn-sm" variant="secondary" onClick={handleResetFilter}>
                        <span className='font-w400'>Reset</span>
                    </Button>
                    <Button className="me-2 btn-sm" variant="primary" onClick={handleGoFilter}>
                        <span className='font-w400'>Go</span>
                    </Button>
                </div>
            </div>
        </Drawer>

        </>
    )


}
export default Quality_Analysis;